<template>
	<form ref="devices_add" @submit.prevent="addDevice">
		<md-card>
			<md-card-header class="md-card-header-icon md-card-header-blue">
				<div class="card-icon">
					<md-icon>add</md-icon>
				</div>
				<h4 class="title">Ajout de dispositif</h4>
			</md-card-header>
			<md-card-content>
				<device-row v-for="newDevice in newDevices" :key="newDevice.idRow"
					:device="newDevice" :deviceTypes="deviceTypes" :errors="errors"
					@duplicate="duplicateDevice"
					@delete="deleteDevice"></device-row>
			</md-card-content>
			<md-card-actions md-alignment="left">
				<md-button type="submit" class="md-success">
					Ajouter
				</md-button>
				<md-button class="md-warning"
						   @click="goBack">
					Retour
				</md-button>
			</md-card-actions>
		</md-card>
	</form>
</template>

<script>
import DeviceRow from "@/pages/Sites/Devices/components/DeviceRow";
export default {
	name: "DeviceAddForm",
	components: { DeviceRow },
	props: {
		deviceTypes: Array
	},
	data() {
		return {
			newDevices: [
				{ idRow: 'newDevice-0', idDeviceType: null, number: null, location: '' }
			],
			errors: []
		}
	},
	methods: {
		duplicateDevice(device) {
			let number = (parseInt(device.number) + 1)
			while(this.newDevices.find(newDevice => newDevice.number === number)) {
				number++
			}
			this.newDevices.push({
				...device,
                idRow: 'newDevice-' + this.newDevices.length,
				number: number
			})
		},
		deleteDevice(device) {
			this.newDevices = this.newDevices.filter(newDevice => { return newDevice.idRow !== device.idRow })
		},
		async addDevice() {
		    this.errors = []
			try {
				await this.$store.dispatch('devices/addDevice', { id: this.$route.params.idSite, devices: this.newDevices })
				await this.$store.dispatch('alerts/success', 'Dispositif(s) ajouté(s)')
                this.$emit('added')
                this.newDevices = [{ idRow: 'newDevice-0', idDeviceType: null, number: null, location: '' }]
			} catch (e) {
                this.errors = e.response.data.errors
			}
		},
		goBack() {
			this.$router.back()
		}
	}
}
</script>

<style scoped>

</style>
